import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=2d5df68e&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=2d5df68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5df68e",
  null
  
)

export default component.exports